import { Container } from "react-bootstrap";
import { GeoAlt } from "react-bootstrap-icons";
import SectionHeading from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
import "../style/NewBranch.css";

const NewBranch = () => {
  return (
    <section className="section-pad new-branch">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="We're Growing"
          title="A New Kote Cafe Has Opened in Navanagar"
          subtitle="Same taste, same team, same love — now closer to even more of Bagalkot."
        />
        <Reveal className="new-branch__copy">
          <p>
            Alongside our original Vidyagiri outlet, we&apos;ve opened a second
            <strong> Kote Cafe</strong> at Sector No. 17, Batakurki Complex,
            Opp. Purushottam Home Decor, Navanagar, Bagalkot — proudly serving
            the same fresh idlis, crisp dosas, and stone-ground BB Batter you
            know and love.
          </p>
          <p className="new-branch__address">
            <GeoAlt size={16} className="me-2" />
            Kote Cafe — Sector No. 17, Batakurki Complex, Opp. Purushottam
            Home Decor, Navanagar, Bagalkot
          </p>
        </Reveal>
        <Reveal className="new-branch__art">
          <img
            src="/images/kote-cafe-navanagar.png"
            alt="Kote Cafe Navanagar new branch announcement — Sector No. 17, Batakurki Complex, Navanagar, Bagalkot"
            className="new-branch__img"
          />
        </Reveal>
      </Container>
    </section>
  );
};

export default NewBranch;
